import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AngularFireDatabase, AngularFireObject } from 'angularfire2/database'
import { Observable } from 'rxjs/Observable';

import * as moment from 'moment';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  moments: Observable<any[]>;
  momentCount: number = 0;
  date: any = moment().format('MMMM Do YYYY');

  constructor(private fireData: AngularFireDatabase, private router: Router) { }

  ngOnInit() {
    this.moments = this.fireData.list(`moments`).valueChanges();
    console.log('look')
    console.log(this.moments)
  }

  login() {
    console.log('log in')
    this.router.navigate(['add-moment']);
  }

}



// WEBPACK FOOTER //
// /Users/jmiller/Projects/Real/j-trip/j-trip/src/app/home/home.component.ts